import { render, staticRenderFns } from "./customTransferTable.vue?vue&type=template&id=432b75ae&scoped=true&"
import script from "./customTransferTable.vue?vue&type=script&lang=js&"
export * from "./customTransferTable.vue?vue&type=script&lang=js&"
import style0 from "./customTransferTable.vue?vue&type=style&index=0&id=432b75ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432b75ae",
  null
  
)

export default component.exports